import { render, staticRenderFns } from "./splitRangeFee.vue?vue&type=template&id=1cd51776"
import script from "./splitRangeFee.vue?vue&type=script&lang=js"
export * from "./splitRangeFee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports